import { COUNTRIES } from '@wareclouds/frontend-common';
import {
  mapBankAccountFieldsCl,
  mapBankAccountFieldsBr,
  mapToBankAccountBrPayload,
  mapToBankAccountClPayload,
} from '../mappers';

import {
  createBankAccountSchemaBr,
  createBankAccountSchemaCl,
  initialValuesBr,
  initialValuesCl,
} from '../index';

export const COUNTRY_CONFIG = {
  [COUNTRIES.CL]: {
    initialValues: initialValuesCl,
    createSchema: createBankAccountSchemaCl,
    mapperBankAccountFields: mapBankAccountFieldsCl,
    mapperToBankAccountPayload: mapToBankAccountClPayload,
  },
  [COUNTRIES.BR]: {
    initialValues: initialValuesBr,
    createSchema: createBankAccountSchemaBr,
    mapperBankAccountFields: mapBankAccountFieldsBr,
    mapperToBankAccountPayload: mapToBankAccountBrPayload,
  },
};
